module.exports = __webpack_public_path__ + "static/le_monde-5b6ac911e49603ca4f7e66dac7ac1c54.png";